import React, { Component, Fragment } from 'react'
import DashboardLayout from '../../components/Admin/DashboardLayout'
import { MDBBtn, MDBCol, MDBContainer, MDBRow } from 'mdb-react-ui-kit'
import MDB4Datatable from '../../components/content/MDB4Datatable/MDB4Datatable.component'
import { toast } from 'react-toastify'
import AdminApi from '../../api/admin-api/admin-api'
import { getHeadshot } from './../../shared/utilities/getHeadshot.function'
import DateManager from './../../shared/utilities/DateManager.class'
import { addWeeks, endOfWeek, format, getWeek, startOfWeek, subWeeks } from 'date-fns'
import './WeeklyAdminReports.scss'

const EMPTY_DATATABLE = {
  columns: [
    { label: 'Rank', field: 'rank', sort: 'disabled', width: 50 },
    { label: 'Agent', field: 'agent', sort: 'disabled', width: 200 },
    { label: 'Date Qualified', field: 'date', sort: 'asc', width: 150 },
  ],
  rows: [],
}

class ConferenceQualifiers extends Component {
  constructor(props) {
    super(props)

    this.state = {
      loading: false,
      currentDate: new Date(),
      dateFrom: startOfWeek(new Date(), { weekStartsOn: 1 }),
      dateTo: endOfWeek(new Date(), { weekStartsOn: 1 }),
      tableData: null,
    }
  }

  componentDidMount() {
    this._fetchReport()
  }

  _fetchReport = async () => {
    this.setState({ loading: true })
    try {
      const { dateFrom, dateTo } = this.state
      const start = format(dateFrom, 'yyyy-MM-dd')
      const stop = format(dateTo, 'yyyy-MM-dd')
      const response = await AdminApi.fetchConferenceQualifiersReport(start, stop)

      if (response && response.data && response.data.data) {
        this.setState({ tableData: this._buildTableData(response.data.data) })
      } else {
        this.setState({ tableData: this._buildTableData([]) })
      }
    } catch (ex) {
      // console.log(ex)
      toast.error('Failed to fetch Conference Qualifiers report.')
    }
    this.setState({ loading: false })
  }

  _buildTableData = rows => {
    return {
      columns: EMPTY_DATATABLE.columns,
      rows: rows.map((row, idx) => ({
        rank: idx + 1,
        agent: (
          <div className='profile-container'>
            <div className='img-wrapper'>
              <div className='profile-img-wrapper qualified'>
                <img src={getHeadshot(row)} alt={`${row.mi_fname} ${row.mi_lname}`} />
              </div>
            </div>
            <div className='agent-name'>
              {row.mi_fname} {row.mi_lname}
              <br />
              <span className='agent-badge'>USABG Conf Qualifier</span>
            </div>
          </div>
        ),
        date: row.mi_date ? format(DateManager.dateOnlyUTCToLocal(row.mi_date), 'MMM dd, yyyy') : '',
      })),
    }
  }

  getPreviousData = () => {
    const { dateFrom } = this.state
    const date = subWeeks(dateFrom, 1)
    this.setState(
      {
        dateFrom: startOfWeek(date, { weekStartsOn: 1 }),
        dateTo: endOfWeek(date, { weekStartsOn: 1 }),
      },
      () => this._fetchReport()
    )
  }

  getCurrentData = () => {
    this.setState(
      {
        dateFrom: startOfWeek(this.state.currentDate, { weekStartsOn: 1 }),
        dateTo: endOfWeek(this.state.currentDate, { weekStartsOn: 1 }),
      },
      () => this._fetchReport()
    )
  }

  getNextData = () => {
    const { dateTo } = this.state
    const date = addWeeks(dateTo, 1)
    this.setState(
      {
        dateFrom: startOfWeek(date, { weekStartsOn: 1 }),
        dateTo: endOfWeek(date, { weekStartsOn: 1 }),
      },
      () => this._fetchReport()
    )
  }

  renderCurrentDatesHeader = () => {
    const { dateFrom, dateTo } = this.state
    const prevFrom = subWeeks(dateFrom, 1),
      prevTo = subWeeks(dateTo, 1)

    return (
      <MDBRow>
        <MDBCol size='12' md='6'>
          <div className='factor-explain'>
            <h3 className='text-center'>Qualifiers Recorded Week #{getWeek(prevFrom)}</h3>
            <p className='text-center'>
              The agents below achieved Conference Qualifier status during the previous business week.
            </p>
            <h4 className='text-center'>
              {format(prevFrom, 'MMM dd, yyyy')} - {format(prevTo, 'MMM dd, yyyy')}
            </h4>
          </div>
        </MDBCol>
        <MDBCol size='12' md='6'>
          <div className='factor-explain'>
            <h3 className='text-center'>Qualifiers Awarding Week #{getWeek(dateFrom)}</h3>
            <p className='text-center'>
              The agents below will be recognized on this week's National Sales Meeting (NSM) for{' '}
              {format(dateFrom, 'EEEE, MMMM do')}.
            </p>
            <h4 className='text-center'>
              {format(dateFrom, 'MMM dd, yyyy')} - {format(dateTo, 'MMM dd, yyyy')}
            </h4>
          </div>
        </MDBCol>
      </MDBRow>
    )
  }

  render() {
    toast.configure()

    return (
      <Fragment>
        <DashboardLayout>
          <main className='mainSection mt-5 pb-5'>
            <MDBContainer fluid id='ConferenceQualifiers' className='WeeklyAdminReportPage'>
              <h3 className='text-center'>Admin Report: Conference Qualifiers</h3>
              <hr />
              {this.state.loading ? (
                <h2>Loading...</h2>
              ) : (
                <>
                  {this.renderCurrentDatesHeader()}
                  <MDBRow className='mt-2 dates-selector'>
                    <MDBCol className='text-center'>
                      <h5>Previous</h5>
                      <MDBBtn
                        type='button'
                        tag='a'
                        flat
                        color='default'
                        className='text-primary btn-flat'
                        onClick={this.getPreviousData}
                      >
                        Week
                      </MDBBtn>
                    </MDBCol>
                    <MDBCol className='text-center'>
                      <h5>Current</h5>
                      <MDBBtn
                        type='button'
                        tag='a'
                        flat
                        color='default'
                        className='text-primary btn-flat'
                        onClick={this.getCurrentData}
                      >
                        Week
                      </MDBBtn>
                    </MDBCol>
                    <MDBCol className='text-center'>
                      <h5>Next</h5>
                      <MDBBtn
                        type='button'
                        color='default'
                        tag='a'
                        flat
                        className='text-primary btn-flat'
                        onClick={this.getNextData}
                      >
                        Week
                      </MDBBtn>
                    </MDBCol>
                  </MDBRow>

                  <MDBRow className='mt-5'>
                    <MDBCol size='12' className='content-wrapper'>
                      <MDB4Datatable
                        data={this.state.tableData || EMPTY_DATATABLE}
                        searching={false}
                        sortable={false}
                        paging={false}
                        displayEntries={false}
                        info={false}
                        noBottomColumns
                        responsive
                        striped
                        bordered
                        className='text-capitalize'
                      />
                    </MDBCol>
                  </MDBRow>
                </>
              )}
            </MDBContainer>
          </main>
        </DashboardLayout>
      </Fragment>
    )
  }
}

export default ConferenceQualifiers
